// frontend/src/auth/RecepcionRoute.js
import React from 'react';
import { useAuth } from './AuthContext';
import { Navigate } from 'react-router-dom';

// Roles con acceso a la configuración del módulo de Recepción (turnero: horarios y cupos).
// ADMIN, PROGRAMADOR, SUPERVISOR y RECEPCION administran o supervisan el turnero.
const RecepcionRoute = ({ children }) => {
    const { puede } = useAuth();

    if (!puede('turnero.config')) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default RecepcionRoute;
